import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const UserDataContext = createContext(null);
export const useUserData = () => useContext(UserDataContext);

export const UserDataProvider = ({ children }) => {
  const { user } = useAuth();
  const [shortlistIds, setShortlistIds] = useState(new Set());
  const [notes, setNotes] = useState({}); // item_id -> text

  const refresh = useCallback(async () => {
    if (!user) { setShortlistIds(new Set()); setNotes({}); return; }
    try {
      const [s, n] = await Promise.all([api.get("/shortlist"), api.get("/notes")]);
      setShortlistIds(new Set(s.data.item_ids));
      const map = {};
      n.data.forEach((x) => { map[x.item_id] = x.text; });
      setNotes(map);
    } catch (e) { console.error("Could not load reader shortlist/notes", e); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const toggleShortlist = async (id) => {
    const r = await api.post(`/shortlist/${id}/toggle`);
    setShortlistIds((prev) => {
      const s = new Set(prev);
      if (r.data.shortlisted) s.add(id); else s.delete(id);
      return s;
    });
    return r.data.shortlisted;
  };

  const saveNote = async (id, text) => {
    const r = await api.put(`/notes/${id}`, { text });
    setNotes((prev) => {
      const m = { ...prev };
      if (r.data.text) m[id] = r.data.text; else delete m[id];
      return m;
    });
    return r.data.text;
  };

  const savedCount = shortlistIds.size;
  const notesCount = Object.keys(notes).length;

  return (
    <UserDataContext.Provider value={{ shortlistIds, notes, toggleShortlist, saveNote, refresh, savedCount, notesCount }}>
      {children}
    </UserDataContext.Provider>
  );
};
